export default {
  title: "Oblíbené produkty",
  label: "Žádné oblíbené produkty nebyly označeny",
  message: `Oblíbené produkty jsou zobrazeny ve vodorovném karuselu a měly by představovat
  produkty, které jsou obecně oblíbené nebo chcete, aby se vaši uživatelé považovali za oblíbené.`,
  select_product: "Přidat oblíbené produkty",
  selected_products: "Oblíbené produkty",
  demo_message_product_slider: "Zde se zobrazí Vámi vybrané 'Oblíbené produkty'."
}
